export default "__VITE_ASSET__be3163da__"